import { Auth0Provider } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import { PropsWithChildren } from "react";

import authConfig from "./auth/config";
import { markFreshLogin } from "./auth/sessionVerification";

interface Auth0ProviderWithNavigateProps {
  children: React.ReactNode;
}

export const Auth0ProviderWithNavigate = ({
  children,
}: PropsWithChildren<Auth0ProviderWithNavigateProps>): JSX.Element | null => {
  const navigate = useNavigate();
  const { domain, clientID, redirectURI, audience } = authConfig;

  if (!(domain && clientID && redirectURI && audience)) {
    return null;
  }

  const onRedirectCallback = (appState) => {
    markFreshLogin();
    navigate(appState?.returnTo || globalThis.location.pathname);
  };
  
  return (
    <Auth0Provider
      domain={domain}
      clientId={clientID}
      authorizationParams={{
        audience: audience,
        redirect_uri: redirectURI,
      }}
      cacheLocation= 'localstorage'
      useRefreshTokens={true}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};